import svg4everybody from 'svg4everybody';
import * as scroll_anchors from './ScrollAnchors';
import * as scroll_fx from '../../core/js/ScrollFX';
import 'core-js/features/array/from';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/includes';
import 'core-js/features/symbol';
import 'core-js/features/symbol/iterator';
import 'core-js/features/object/assign';
import 'core-js/features/object/values';
import 'core-js/features/number/is-integer';
import 'core-js/features/string/includes';

import './utils/togglr';
import './utils/typewriter';
import './utils/cyclr';
import './utils/clipboard';
import './utils/img-hover-changer';
import './components/c-nav';
import './components/c-popup';
import './components/c-js-expandable';
import './components/js-cycler';
import './components/js-increment2';
import './components/js-countdown-to';
import './components/js-site-growl';
import './components/js-smart-ellipsis';
import './components/js-sitewide-ui-notification';
import './components/c-tiny-slider';
import './forms';
import './cookies/crumblr';
import './images/image-set';
import './images/lazy-load';
import './video/video-playback';
import './video/video-bg';
import './charts';
import './cookies/cookie-monster';
// import './parallax/rellax';

svg4everybody();
scroll_anchors.auto_add();
scroll_fx.auto_init();

